import {
  CPC,
  CPM,
  VIEWABLE_CPM
} from '../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/InventoryAccessAndAllocationSection/SubAllocationTables/fields'
import { formatStringWithUnderscore } from '../../../../../../helpers/common'

export const formatUnitType = billingEvent => {
  switch (billingEvent) {
    case CPC:
      return 'CLICKS'
    case VIEWABLE_CPM:
      return 'VIEWABLE_IMPRESSIONS'
    case CPM:
    default:
      return 'IMPRESSIONS'
  }
}

export const getUnitTypeLabel = billingEvent => {
  return formatStringWithUnderscore(formatUnitType(billingEvent)).toLowerCase()
}
